import { styled as materialStyled } from "@mui/material/styles";
import { TabPanel } from "@mui/lab";
import React from "react";
import SyntaxHighlighter from "react-syntax-highlighter";
import { stackoverflowDark } from "react-syntax-highlighter/dist/esm/styles/hljs";

const CodeGenerationTab = ({
  display,
  generatedCode,
}: {
  display: boolean;
  generatedCode?: string;
}) => {
  return (
    <ConsoleLogsTable keepMounted value={"3"} display={display}>
      <SyntaxHighlighter
        language="java"
        style={stackoverflowDark}
        customStyle={{
          width: "100%",
        }}
      >
        {generatedCode != null && generatedCode.trim() !== ""
          ? generatedCode
          : "No code generated yet, it will be available in some minutes"}
      </SyntaxHighlighter>
    </ConsoleLogsTable>
  );
};

const ConsoleLogsTable = materialStyled(TabPanel)(
  ({ display }: { display: boolean }) =>
    display
      ? {
          display: "grid",
          "--network-logs-table-gap": "16px",
          columnGap: "var(--network-logs-table-gap)",
          marginTop: "var(--network-logs-table-gap)",
          justifyItems: "start",
          transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
          backgroundImage:
            "linear-gradient(rgba(255, 255, 255, 0.07), rgba(255, 255, 255, 0.07))",
          boxShadow:
            "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
          borderRadius: "4px",
        }
      : {}
);

export default CodeGenerationTab;
